@if (collectionSize > 0) {
  <nav class="pagination-wrapper" data-cy="dashboard__pagination">
    <ul class="pagination">
      <!-- previous button -->
      @if (nextPreviousButtons) {
        <li  [class]="currentPage === 1 ? 'page-item disabled' : 'page-item'">
          <button  [class]="currentPage === 1 ? 'page-link disabled' : 'page-link'"
            data-cy="dashboard__pagination__previous"
            [disabled]="currentPage === 1"
            (click)="previous()">
            <ion-icon name="chevron-back-outline" size="small"></ion-icon>
          </button>
        </li>
      }
      <!-- page numbers -->
      @if (currentPaginationState === 'LOWER') {
        @for (p of totalPages; track $index; let i = $index) {
          @if (i + 1 <= 5) {
            <li
              [class]="currentPage === (i  + 1) ? 'page-item active' : 'page-item'">
              <button  class="page-link" [attr.data-cy]="'dashboard__pagination__page_' + (i + 1)" (click)="selectPageNumber(i + 1)">{{i + 1}}</button>
            </li>
          }
          @if (i === 5 && totalPages.length > 6) {
            <li class="page-item disabled">
              <button class="page-link" disabled>
                ...
              </button>
            </li>
          }
          @if (i >= 5 && i > totalPages.length - 2) {
            <li
              [class]="currentPage === (i  + 1) ? 'page-item active' : 'page-item'">
              <button  class="page-link" [attr.data-cy]="'dashboard__pagination__page_' + (i + 1)" (click)="selectPageNumber(i + 1)">{{i + 1}}</button>
            </li>
          }
        }
      }
      <!-- page numbers -->
      @if (currentPaginationState === 'MID') {
        @for (p of totalPages; track $index; let i = $index) {
          @if (i < 1) {
            <li
              [class]="currentPage === (i  + 1) ? 'page-item active' : 'page-item'">
              <button  class="page-link" [attr.data-cy]="'dashboard__pagination__page_' + (i + 1)" (click)="selectPageNumber(i + 1)">{{i + 1}}</button>
            </li>
          }
          @if (i === 1 && i !== currentPage - 1) {
            <li class="page-item disabled">
              <button class="page-link" disabled>
                ...
              </button>
            </li>
          }
          @if (i > currentPage - 3 && i < currentPage + 1) {
            <li
              [class]="currentPage === (i  + 1) ? 'page-item active' : 'page-item'">
              <button  class="page-link" [attr.data-cy]="'dashboard__pagination__page_' + (i + 1)" (click)="selectPageNumber(i + 1)">{{i + 1}}</button>
            </li>
          }
          @if (i === totalPages.length - 1 && i !== currentPage) {
            <li class="page-item disabled">
              <button class="page-link" disabled>
                ...
              </button>
            </li>
          }
          @if (i === totalPages.length - 1) {
            <li
              [class]="currentPage === (i  + 1) ? 'page-item active' : 'page-item'">
              <button  class="page-link" [attr.data-cy]="'dashboard__pagination__page_' + (i + 1)" (click)="selectPageNumber(i + 1)">{{i + 1}}</button>
            </li>
          }
        }
      }
      <!-- page numbers -->
      @if (currentPaginationState === 'UPPER') {
        @for (p of totalPages; track $index; let i = $index) {
          @if (i < 1) {
            <li
              [class]="currentPage === (i  + 1) ? 'page-item active' : 'page-item'">
              <button  class="page-link" [attr.data-cy]="'dashboard__pagination__page_' + (i + 1)" (click)="selectPageNumber(i + 1)">{{i + 1}}</button>
            </li>
          }
          @if (i === 1 && i !== totalPages.length - 5) {
            <li class="page-item disabled">
              <button class="page-link" disabled>
                ...
              </button>
            </li>
          }
          @if (i >= totalPages.length - 5) {
            <li
              [class]="currentPage === (i  + 1) ? 'page-item active' : 'page-item'">
              <button  class="page-link" [attr.data-cy]="'dashboard__pagination__page_' + (i + 1)" (click)="selectPageNumber(i + 1)">{{i + 1}}</button>
            </li>
          }
        }
      }
      <!-- next button -->
      @if (nextPreviousButtons && totalPages.length > 1) {
        <li [class]="currentPage === totalPages.length ? 'page-item disabled' : 'page-item'"
          >
          <button  [class]="currentPage === totalPages.length ? 'page-link disabled' : 'page-link'"
            data-cy="dashboard__pagination__next"
            [disabled]="currentPage === totalPages.length"
            (click)="next()">
            <ion-icon name="chevron-forward-outline" size="small"></ion-icon>
          </button>
        </li>
      }
    </ul>
  </nav>
}
